export class InsuranceModel {
  key: string;
  text: string;
  subText: string;
  isShownSubText: boolean;
  indexOfChosenPolicy: number;
  newPolicyDefaultOptions: Array<string>;
  addedPolicyDefaultOptions: Array<string>;
  products: Array<any>;
  questionRaws: Array<any>;
  policies: Array<{}>;

  constructor() {
    this.policies = new Array<{}>();
  }
}

export class AddedPolicyDataModel {
  key: string;
  indexOfChosenPolicy: number;
  title: string;
  policy: any;
  questionRaws: Array<any>;
  labels: Array<{ key: string; value: string }>;

  constructor() {
    this.key = '';
    this.indexOfChosenPolicy = 0;
    this.title = '';
    this.policy = new Object;
    this.questionRaws = new Array<any>();
    this.labels = new Array<{ key: string; value: string }>();
  }
}



// WEBPACK FOOTER //
// ./src/app/features/coverage/model.ts